<template>
  <div>
    <div class="sac__font-18 med">
      How to reach us
    </div>
    <div class="card grid-column even">
      <div class="grid-column ai-c jc-s gap-30">
        <div class="profile-circle">
          {{ getInitials }}
        </div>
        <div>
          <div class="sac__font-16 med n60">
            Today's Presenter:
          </div>
          <div class="sac__font-40 semi-bold n60">
            {{ presenterInfo }}
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="grid-column ai-c gap-30">
          <img
            src="@shared/assets/img/performance-summary/app-home.png"
            class="app-img"
            alt="app"
          />
          <img
            src="@shared/assets/img/performance-summary/app-tech-chat.png"
            class="app-img"
            alt="app"
          />
        </div>
        <div class="sac__font-18 n60 med margin-top-16">
          “My Tech” in the Member App
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'PresenterInfo',
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      presenterInfo() {
        const {
          firstName,
          lastName,
        } = this.currentAdmin;
        return `${firstName} ${lastName}`;
      },
      getInitials() {
        const {
          firstName,
          lastName,
        } = this.currentAdmin;
        return `${firstName.charAt(0)}${lastName.charAt(0)}`;
      },
    }),
  },
};
</script>

<style scoped lang="scss">
.card {
  padding: 2rem;
  border-radius: 8px;
  display: grid;
  gap: 0.875rem;
  background-color: $N5;
  margin-top: 1rem;
  min-height: 15rem;
  .profile-circle {
    height: 130px;
    width: 130px;
    display: grid;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 4px solid $N60;
    color: $N60;
    font-size: 2.5rem;
  }
  .right-content {
    display: grid;
    justify-items: center;
    .app-img {
      height: 21rem;
      width: 10rem;
    }
  }
}
</style>
